import { render, staticRenderFns } from "./matching-card-percentage-pill.vue?vue&type=template&id=6c09c00f&scoped=true&"
import script from "./matching-card-percentage-pill.vue?vue&type=script&lang=ts&"
export * from "./matching-card-percentage-pill.vue?vue&type=script&lang=ts&"
import style0 from "./matching-card-percentage-pill.vue?vue&type=style&index=0&id=6c09c00f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c09c00f",
  null
  
)

export default component.exports